/* -------------------------------------------------------------------------
 * Sayuri signature · snow-fall  (Heart of Himavat)
 * -------------------------------------------------------------------------
 * Port of `SnowFall` in the design file (line ~1091). Tiny white glowing
 * crystals falling linearly on 3 drift paths. No spin, no sway — just
 * clean vertical descent.
 *
 * Scent character: "Ice on a juniper branch, distant pine, a silver
 * morning." Cold + crystalline + pure.
 * ----------------------------------------------------------------------- */
(function () {
  'use strict';
  var SA = window.SayuriAnimations;
  if (!SA) { return; }

  SA.register('snow-fall', {
    mount: function (el, ctx) {
      var n = ctx.intensity === 'lush' ? 50 : 30;
      var rand = ctx.seed('snow-fall'.charCodeAt(0) * 131 + 9 * 7919);

      var frag = document.createDocumentFragment();
      for (var i = 0; i < n; i++) {
        var left = rand() * 100;
        var size = 3 + rand() * 6;        // 3–9px
        var dur = 30 + rand() * 22;       // 30–52s (was 16–30s; Himalayan stillness)
        var delay = -rand() * 40;
        var opacity = 0.5 + rand() * 0.5; // 0.5–1.0
        var variant = i % 3;

        var p = document.createElement('div');
        p.className = 'sayuri-snow';
        p.style.position = 'absolute';
        p.style.top = '-20px';
        p.style.left = left + 'vw';
        p.style.width = size + 'px';
        p.style.height = size + 'px';
        p.style.borderRadius = '50%';
        p.style.background = 'radial-gradient(circle, #fff, #ffffff00 70%)';
        p.style.boxShadow = '0 0 ' + (size * 2) + 'px #ffffffaa';
        p.style.opacity = opacity;
        p.style.animation = 'snow-fall-' + variant + ' ' + dur + 's linear ' + delay + 's infinite';

        frag.appendChild(p);
      }
      el.appendChild(frag);
    },
    css: [
      '@keyframes snow-fall-0 { 0%{transform:translate3d(0,0,0);} 100%{transform:translate3d(20px,110vh,0);} }',
      '@keyframes snow-fall-1 { 0%{transform:translate3d(0,0,0);} 100%{transform:translate3d(-30px,110vh,0);} }',
      '@keyframes snow-fall-2 { 0%{transform:translate3d(0,0,0);} 100%{transform:translate3d(10px,110vh,0);} }'
    ].join('')
  });
})();
